import { render, staticRenderFns } from "./OverviewHeader.vue?vue&type=template&id=a56fb72e&scoped=true"
import script from "./OverviewHeader.vue?vue&type=script&lang=js"
export * from "./OverviewHeader.vue?vue&type=script&lang=js"
import style0 from "./OverviewHeader.vue?vue&type=style&index=0&id=a56fb72e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../TweeAT.HvA.CourseCatalog/ClientApp/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a56fb72e",
  null
  
)

export default component.exports